"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailInvalid = exports.BarNumberInvalid = exports.LicenseFormValid = exports.UserFormValid = exports.SetupUser = void 0;
const lodash_1 = __importDefault(require("lodash"));
const api_1 = require("../../../../services/api");
const common_1 = require("../../../../utils/common");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const pick_1 = __importDefault(require("lodash/pick"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const editable = [
    'bio',
    'pro_bono',
    'phone',
    'additional_phone',
    'email',
    'contact_person',
    'city',
    'zipCode',
    'address',
    'name',
    'state',
    'hourly_rate'
];
const errors = {
    name: "Please add a full name.",
    email: "Email is required.",
    validEmail: "Please add a valid email address.",
    emailExists: "This email is already registered.",
    validPhone: "Please add a valid phone number.",
    password: "Password is required.",
    phone: "Phone number is required.",
    bio: "Bio is required.",
    duplicateBarNumber: 'The license entered is already registered.',
    blockedLicence: 'This license is blocked.',
    state: 'Please select a state before adding a license.',
    license: 'Please enter a license.',
    zipCode: "Please add a valid zip code.",
    city: "Please enter a city.",
    address: "Please enter an address.",
    hourlyRate: 'Hourly rate is required.'
};
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,50}$/;
//async validations
const EmailInvalid = async (email) => {
    if (email && emailPattern.test(email) === false || !email) {
        return errors.validEmail;
    }
    const user = await api_1.Auth.ifMailRegistered(email);
    if (user) {
        return errors.emailExists;
    }
    return null;
};
exports.EmailInvalid = EmailInvalid;
const BarNumberInvalid = async (user, stateId, barNumber) => {
    if (!barNumber)
        return errors.barNumber;
    if (!stateId)
        return errors.stateForBarNumber;
    const data = {
        user,
        state: stateId,
        barNumber: barNumber.toString().trim(),
    };
    try {
        const res = await api_1.Auth.checkBarNumber(data);
        if (res && res.responseJSON && res.responseJSON.originalError === 'BN_BLOCKED') {
            return errors.blockedLicence;
        }
        return (res && res.length) ? errors.duplicateBarNumber : false;
    }
    catch (e) {
        if (e && e.responseJSON && e.responseJSON.originalError === 'BN_BLOCKED') {
            return errors.blockedLicence;
        }
    }
};
exports.BarNumberInvalid = BarNumberInvalid;
//async validations end
const UserFormValid = (data, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { user } = action;
    const newForm = Object.assign({}, data.data);
    const prop = newForm[action.field];
    let { addressGroupError } = data;
    const customFields = ['name', 'email', 'phone', 'additional_phone'];
    const addressGroup = ['address', 'city', 'state', 'zipCode'];
    const addressGroupFields = Object.values(lodash_1.default.pick(newForm, ['address', 'city', 'zipCode']));
    if (prop) {
        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true;
        }
        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }
        if (action.apiError) {
            prop.apiError = action.apiError;
        }
        else {
            prop.apiError = null;
        }
        if (action.field === 'name') {
            const splitted = action === null || action === void 0 ? void 0 : action.value.split(' ').filter(el => el !== '');
            const l = splitted[1] && splitted[1].length > 1 ? (_a = splitted[1]) === null || _a === void 0 ? void 0 : _a.trim() : true;
            if (!l || (splitted === null || splitted === void 0 ? void 0 : splitted.length) < 2 || (action === null || action === void 0 ? void 0 : action.value.replace(/\s/g, '').length) < 4) {
                prop.error = errors.name;
            }
            else {
                prop.error = !action.value ? errors.name : null;
            }
        }
        if (action.field === 'email') {
            prop.error = action.value && emailPattern.test(action.value) === false || !action.value ? errors.validEmail : null;
        }
        if (action.field === 'phone') {
            prop.error = !action.value || ((_b = action === null || action === void 0 ? void 0 : action.value) === null || _b === void 0 ? void 0 : _b.trim().length) < 14 ? errors['validPhone'] : null;
        }
        if (action.field === 'additional_phone') {
            prop.error = /\d/.test((_c = action === null || action === void 0 ? void 0 : action.value) === null || _c === void 0 ? void 0 : _c.trim()) && ((_d = action === null || action === void 0 ? void 0 : action.value) === null || _d === void 0 ? void 0 : _d.trim().length) < 14 ? errors['validPhone'] : null;
            prop.required = !!prop.error;
        }
        if (!customFields.includes(action.field)) {
            let checkSpace = false;
            if (typeof action.value === "string") {
                checkSpace = !action.value.replace(/\s/g, '').length;
            }
            prop.error = (prop.added && (!action.value || checkSpace) && prop.required) ? errors[action.field] : null;
        }
        if (action.field === 'hourly_rate') {
            action.value = (_e = action.value) === null || _e === void 0 ? void 0 : _e.replace(/^0+/, '').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
            if (user.linked_lf.activated === 1) {
                prop.error = !parseFloat(action.value) ? errors.hourlyRate : null;
            }
        }
        prop.value = action.value;
    }
    const anyValue = addressGroupFields.some(((g) => g.value));
    const anyError = addressGroupFields.some(((g) => g.error));
    if (!anyError) {
        addressGroupError = [];
    }
    if (addressGroup.includes(action === null || action === void 0 ? void 0 : action.field) || (anyError && action.validate)) {
        for (const a of addressGroup) {
            const propG = newForm[a];
            if (!propG.dirty) {
                propG.dirty = true;
            }
            if (a === 'city' || a === 'address') {
                const trimed = (_f = propG === null || propG === void 0 ? void 0 : propG.value) === null || _f === void 0 ? void 0 : _f.trim();
                if (!trimed && anyValue) {
                    propG.error = true;
                    propG.value = '';
                }
                else {
                    propG.error = null;
                }
            }
            else {
                const stProp = (propG === null || propG === void 0 ? void 0 : propG.value) || '';
                const length = stProp.toString().length || 0;
                propG.error = anyValue && (!(propG === null || propG === void 0 ? void 0 : propG.value) || (propG.value && (propG.min && propG.min > length))) ? true : null;
            }
            addressGroupError.push(propG.error);
        }
        //build full address
        if (newForm.address.value && newForm.city.value &&
            ((_g = newForm.state) === null || _g === void 0 ? void 0 : _g.value) && ((_j = (_h = newForm.state) === null || _h === void 0 ? void 0 : _h.value) === null || _j === void 0 ? void 0 : _j.state_id) != '-1' &&
            newForm.zipCode.value) {
            newForm.full_address.value = `${newForm.address.value}, ${newForm.city.value}, ${(_l = (_k = newForm.state) === null || _k === void 0 ? void 0 : _k.value) === null || _l === void 0 ? void 0 : _l.abbreviation} ${newForm.zipCode.value} `;
        }
        else {
            newForm.full_address.value = null;
        }
        //build full address end
    }
    const vals = Object.values(newForm).filter((f) => f.required);
    const valid = vals.filter((f) => f.added && f.value && !f.error);
    let hourlyRateValid = true;
    if (user.linked_lf.activated === 1) {
        hourlyRateValid = !!parseFloat(newForm.hourly_rate.value);
    }
    return {
        addressGroupError,
        changed: hasChangedForm(newForm, action.user),
        valid: addressGroupError.includes(true) || !hourlyRateValid ? false : valid.length === vals.length && !action.apiError,
        data: newForm,
    };
};
exports.UserFormValid = UserFormValid;
const hasChangedForm = (form, user) => {
    var _a, _b, _c, _d;
    const newData = {};
    const newForm = cloneDeep_1.default(form);
    if ((_b = (_a = newForm.state) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.state_id) {
        newForm.state.value = `${(_d = (_c = newForm.state) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.state_id}`;
    }
    else {
        newForm.state.value = '-1';
    }
    Object.entries(newForm)
        .map((val) => newData[val[0]] = val[1].value);
    return !isEqual_1.default(pick_1.default(newData, editable), pick_1.default(user, editable));
};
const LicenseFormValid = (data, action) => {
    var _a, _b, _c, _d;
    const newForm = Object.assign({}, data.data);
    const prop = newForm[action.field];
    const coupleField = action.field == 'state' ? 'license' : 'state';
    const validatedField = !action.value ? action.field : coupleField;
    let changed = true;
    if (prop) {
        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true;
        }
        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }
        if (action.apiError) {
            prop.apiError = action.apiError;
        }
        else {
            prop.apiError = null;
        }
        if (action.value && !newForm[coupleField].value || !action.value && newForm[coupleField].value) {
            newForm[validatedField].error = newForm[validatedField].dirty ? errors[validatedField] : null;
        }
        else {
            prop.error = (prop.added && !action.value && prop.required) ? errors[action.field] : null;
        }
        prop.value = action.value;
    }
    if (!action.value && !newForm[coupleField].value) {
        newForm.state.error = null;
        newForm.license.error = null;
        changed = false;
    }
    return {
        changed,
        valid: !!(!action.apiError && ((!((_a = newForm === null || newForm === void 0 ? void 0 : newForm.license) === null || _a === void 0 ? void 0 : _a.value) && !((_b = newForm === null || newForm === void 0 ? void 0 : newForm.state) === null || _b === void 0 ? void 0 : _b.value)) || (((_c = newForm === null || newForm === void 0 ? void 0 : newForm.license) === null || _c === void 0 ? void 0 : _c.value) && ((_d = newForm === null || newForm === void 0 ? void 0 : newForm.state) === null || _d === void 0 ? void 0 : _d.value)))),
        data: newForm,
    };
};
exports.LicenseFormValid = LicenseFormValid;
const SetupUser = (data, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const newForm = Object.assign({}, data.data);
    const { payload, states } = action;
    let addressGroupError = [];
    newForm.name.value = `${payload.name}`;
    newForm.name.added = !!newForm.name.value;
    newForm.bio.value = payload.bio;
    newForm.bio.added = !!payload.bio;
    // newForm.bio.error = !newForm.bio.value ? errors['bio'] : null;
    if (newForm.bio.value) {
        newForm.bio.value = common_1.reReplaceChars(newForm.bio.value);
    }
    newForm.pro_bono.value = payload.pro_bono;
    newForm.pro_bono.added = !!payload.pro_bono;
    newForm.hourly_rate.value = payload.hourly_rate;
    newForm.hourly_rate.added = !!parseFloat(payload.hourly_rate);
    newForm.email.value = payload.email;
    newForm.email.origin = payload.email;
    newForm.email.added = !!newForm.email.value;
    newForm.email.error = !emailPattern.test(payload.email) ? errors['email'] : null;
    newForm.phone.value = payload.phone;
    newForm.phone.added = !!newForm.phone.value;
    newForm.phone.error = newForm.phone.value && ((_b = (_a = newForm.phone) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim().length) < 14 ? errors['validPhone'] : null;
    newForm.additional_phone.value = payload.additional_phone;
    newForm.additional_phone.added = !!newForm.additional_phone.value;
    newForm.additional_phone.error = newForm.additional_phone.value && ((_c = newForm === null || newForm === void 0 ? void 0 : newForm.additional_phone) === null || _c === void 0 ? void 0 : _c.value.trim().length) < 14 ? errors['validPhone'] : null;
    newForm.contact_person.value = payload.contact_person;
    newForm.contact_person.added = !!newForm.contact_person.value;
    newForm.address.value = payload.address;
    newForm.address.added = !!newForm.address.value;
    newForm.city.value = payload.city;
    newForm.city.added = !!newForm.city.value;
    const addressState = states.find((s) => s.id == payload.state);
    newForm.state.value = addressState ? {
        state_id: addressState.id || payload.state,
        state_name: addressState.name || payload.userStateName,
        abbreviation: addressState.abbreviation
    } : null;
    newForm.state.added = !!newForm.state.value;
    newForm.zipCode.value = payload.zipCode;
    newForm.zipCode.added = !!newForm.zipCode.value;
    if (!newForm.zipCode.value && !newForm.city.value && !newForm.address.value) {
        //helper
    }
    else {
        newForm.zipCode.error = newForm.zipCode.value && ((_d = newForm.zipCode.value) === null || _d === void 0 ? void 0 : _d.length) < 5 ? errors['zipCode'] : null;
        newForm.address.error = !newForm.address.value ? errors['address'] : null;
        newForm.city.error = !newForm.city.value ? errors['city'] : null;
        addressGroupError = [!!newForm.zipCode.error, !!newForm.city.error, !!newForm.address.error];
    }
    if (!newForm.address.value || !newForm.city.value || !((_f = (_e = newForm.state) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.abbreviation) || !newForm.zipCode.value) {
        newForm.full_address.value = null;
    }
    else {
        newForm.full_address.value = `${newForm.address.value}, ${newForm.city.value}, ${(_h = (_g = newForm.state) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.abbreviation} ${newForm.zipCode.value} `;
    }
    return {
        addressGroupError,
        changed: false,
        valid: true,
        data: newForm,
    };
};
exports.SetupUser = SetupUser;
